(function () {
  'use strict';

  const SUPABASE_URL = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );

      if (!key) return null;

      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Admin Revision] Session error:', error);
      return null;
    }
  }

  function getAccessToken() {
    return getSession()?.access_token || null;
  }

  async function rpc(functionName, payload = {}) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/${functionName}`,
      {
        method: 'POST',
        headers: {
          apikey: PUBLISHABLE_KEY,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    );

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  async function restGet(path) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method: 'GET',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: `Bearer ${accessToken}`
      }
    });

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function resolveVersionId(row) {
    const directId =
      row.document_version_id ||
      row.version_id ||
      row.controlled_document_version_id;

    if (directId) return directId;

    const documentCode = row.document_code;
    const versionNumber = row.version_number;

    if (!documentCode || !versionNumber) {
      throw new Error(
        'Unable to identify this document version.'
      );
    }

    const documents = await restGet(
      `controlled_documents?select=id&document_code=eq.${encodeURIComponent(documentCode)}&limit=1`
    );

    if (!Array.isArray(documents) || !documents.length) {
      throw new Error(`Document ${documentCode} could not be found.`);
    }

    const documentId = documents[0].id;

    const versions = await restGet(
      `controlled_document_versions?select=id&document_id=eq.${encodeURIComponent(documentId)}&version_number=eq.${encodeURIComponent(versionNumber)}&limit=1`
    );

    if (!Array.isArray(versions) || !versions.length) {
      throw new Error(
        `Version ${versionNumber} for ${documentCode} could not be found.`
      );
    }

    return versions[0].id;
  }

  function injectStyles() {
    if (document.getElementById('cvnAdminRevisionStyles')) return;

    const style = document.createElement('style');
    style.id = 'cvnAdminRevisionStyles';

    style.textContent = `
      #cvnRevisionLauncher {
        appearance: none;
        border: 1px solid #536178;
        background: #17243a;
        color: #ffffff;
        font-weight: 700;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 10px;
      }

      #cvnRevisionLauncher:hover {
        border-color: #19B5B0;
      }

      #cvnRevisionOverlay {
        position: fixed;
        inset: 0;
        z-index: 13000;
        background: rgba(3, 8, 18, .80);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      #cvnRevisionPanel {
        width: min(720px, 96vw);
        max-height: 90vh;
        overflow-y: auto;
        background: #0B1426;
        color: #ffffff;
        border: 1px solid rgba(25,181,176,.35);
        border-radius: 16px;
        padding: 26px;
        box-shadow: 0 24px 70px rgba(0,0,0,.45);
      }

      #cvnRevisionPanel h2 {
       margin: 0 0 7px;
       font-size: 25px;
       color: #ffffff !important;
       font-weight: 700;
       }

      .cvn-revision-subtitle {
        color: #aab6c9;
        line-height: 1.5;
        margin-bottom: 22px;
      }

      #cvnRevisionMessage {
        display: none;
        margin-bottom: 16px;
        padding: 11px 13px;
        border-radius: 8px;
      }

      #cvnRevisionMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.45);
        color: #cffffb;
      }

      #cvnRevisionMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }

      .cvn-revision-field {
        margin-bottom: 18px;
      }

      .cvn-revision-field label {
        display: block;
        font-size: 13px;
        font-weight: 700;
        color: #d7e0ec;!important;
        margin-bottom: 7px;
      }

      .cvn-revision-field select,
      .cvn-revision-field input,
      .cvn-revision-field textarea {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #31415a;
        background: #111d31;
        color: #ffffff;
        border-radius: 8px;
        padding: 12px;
        font: inherit;
      }

      .cvn-revision-field textarea {
        min-height: 110px;
        resize: vertical;
      }

      .cvn-revision-notice {
        margin: 18px 0 22px;
        padding: 13px 14px;
        border-left: 3px solid #19B5B0;
        background: rgba(25,181,176,.07);
        color: #c7d2df;
        line-height: 1.55;
        font-size: 14px;
      }

      .cvn-revision-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #26354c;
        padding-top: 20px;
      }

      .cvn-revision-actions button {
        border-radius: 8px;
        padding: 11px 18px;
        font-weight: 700;
        cursor: pointer;
      }

      #cvnRevisionCancel {
        background: transparent;
        border: 1px solid #536178;
        color: #ffffff;
      }

      #cvnRevisionSubmit {
        background: #19B5B0;
        border: 1px solid #19B5B0;
        color: #07101f;
      }

      #cvnRevisionSubmit:disabled {
        opacity: .55;
        cursor: not-allowed;
      }

      .cvn-revision-empty {
        padding: 18px;
        border: 1px solid #31415a;
        border-radius: 9px;
        color: #aab6c9;
      }
    `;

    document.head.appendChild(style);
  }

  function closeModal() {
    document.getElementById('cvnRevisionOverlay')?.remove();
  }

  function showMessage(message, type) {
    const el = document.getElementById('cvnRevisionMessage');
    if (!el) return;

    el.className = type;
    el.textContent = message;
  }

  async function refreshAdminRegister() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return;

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    if (refreshButton) {
      setTimeout(() => refreshButton.click(), 300);
    }
  }

      async function openRevisionModal(
  preferredDocumentCode = null,
  preferredVersionNumber = null
) {

  const overlay = document.createElement('div');
  overlay.id = 'cvnRevisionOverlay';

    overlay.innerHTML = `
      <div id="cvnRevisionPanel">
        <h2>Create Controlled Document Revision</h2>

        <div class="cvn-revision-subtitle">
          Create a new draft version from an approved controlled document while
          preserving the approved source version and its audit history.
        </div>

        <div id="cvnRevisionMessage"></div>

        <div id="cvnRevisionContent">
          Loading approved controlled documents...
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    try {
      const register = await rpc(
  'get_admin_controlled_document_register',
  {}
);
      if (!Array.isArray(register)) {
  throw new Error('The controlled-document register could not be loaded.');
}


      const approved = register.filter(
  (row) =>
    String(row.version_status || '').toLowerCase() === 'approved'
);

const preferredIndex = approved.findIndex(
  (row) =>
    String(row.document_code) === String(preferredDocumentCode) &&
    String(row.version_number) === String(preferredVersionNumber)
);

const content = document.getElementById('cvnRevisionContent');

      if (!approved.length) {
        content.innerHTML = `
          <div class="cvn-revision-empty">
            No approved controlled-document versions are available for revision.
          </div>

          <div class="cvn-revision-actions">
            <button id="cvnRevisionCancel" type="button">Close</button>
          </div>
        `;

        document
          .getElementById('cvnRevisionCancel')
          .addEventListener('click', closeModal);

        return;
      }

           const options = approved
        .map((row, index) => {
          const code = escapeHtml(row.document_code);
          const title = escapeHtml(row.title);
          const version = escapeHtml(row.version_number);

          return `
            <option
              value="${index}"
              ${index === preferredIndex ? 'selected' : ''}
            >
              ${code} — ${title} — Version ${version}
            </option>
          `;
        })
        .join('');

      content.innerHTML = `
        <div class="cvn-revision-field">
          <label for="cvnRevisionSource">Approved Source Version *</label>

          <select id="cvnRevisionSource">
            ${options}
          </select>
        </div>

        <div class="cvn-revision-field">
          <label for="cvnRevisionVersion">New Version Number *</label>

          <input
            id="cvnRevisionVersion"
            type="text"
            placeholder="Example: 1.1"
          >
        </div>

        <div class="cvn-revision-field">
          <label for="cvnRevisionSummary">Change Summary *</label>

          <textarea
            id="cvnRevisionSummary"
            placeholder="Describe why this new controlled version is being created."
          ></textarea>
        </div>

        <div class="cvn-revision-notice">
          The approved source version will not be edited or replaced.
          A separate Draft version will be created with its own version number
          and change history.
        </div>

        <div class="cvn-revision-actions">
          <button id="cvnRevisionCancel" type="button">Cancel</button>
          <button id="cvnRevisionSubmit" type="button">Create Revision</button>
        </div>
      `;
       const sourceSelect =
  document.getElementById(
    'cvnRevisionSource'
  );

if (
  sourceSelect &&
  preferredIndex >= 0
) {
  sourceSelect.value =
    String(preferredIndex);
}
      document
        .getElementById('cvnRevisionCancel')
        .addEventListener('click', closeModal);

      document
        .getElementById('cvnRevisionSubmit')
        .addEventListener('click', async function () {
          const button = this;

          const selectedIndex = Number(
            document.getElementById('cvnRevisionSource').value
          );

          const selectedRow = approved[selectedIndex];

          if (!selectedRow) {
            showMessage(
              'Please select a valid approved source version.',
              'error'
            );
            return;
          }

          const newVersion =
            document.getElementById('cvnRevisionVersion').value.trim();

          const changeSummary =
            document.getElementById('cvnRevisionSummary').value.trim();

          if (!newVersion) {
            showMessage(
              'New Version Number is required.',
              'error'
            );
            return;
          }

          if (!changeSummary) {
            showMessage(
              'Change Summary is required.',
              'error'
            );
            return;
          }

          if (newVersion === String(selectedRow.version_number)) {
            showMessage(
              'The new version number must be different from the approved source version.',
              'error'
            );
            return;
          }

          const code = selectedRow.document_code;
          const sourceVersion = selectedRow.version_number;

          button.disabled = true;
          button.textContent = 'Creating...';

          try {
            const sourceVersionId =
              await resolveVersionId(selectedRow);

            const result = await rpc(
              'create_controlled_document_version',
              {
                p_source_version_id: sourceVersionId,
                p_new_version_number: newVersion,
                p_change_summary: changeSummary
              }
            );

            console.log(
              '[Corevian Admin Revision] Revision created:',
              result
            );

            showMessage(
              `${code} Version ${newVersion} was created successfully from approved Version ${sourceVersion}.`,
              'success'
            );

            await refreshAdminRegister();

            setTimeout(closeModal, 1500);

          } catch (error) {
            console.error(
              '[Corevian Admin Revision] Revision failed:',
              error
            );

            showMessage(
              error.message || 'Unable to create document revision.',
              'error'
            );

            button.disabled = false;
            button.textContent = 'Create Revision';
          }
        });

    } catch (error) {
      console.error(
        '[Corevian Admin Revision] Unable to load approved versions:',
        error
      );

      const content = document.getElementById('cvnRevisionContent');

      content.innerHTML = `
        <div class="cvn-revision-empty">
          Unable to load approved controlled documents.
        </div>

        <div class="cvn-revision-actions">
          <button id="cvnRevisionCancel" type="button">Close</button>
        </div>
      `;

      showMessage(error.message, 'error');

      document
        .getElementById('cvnRevisionCancel')
        .addEventListener('click', closeModal);
    }
  }

  function installLauncher() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return false;

    if (document.getElementById('cvnRevisionLauncher')) {
      return true;
    }

    const approveButton =
      document.getElementById('cvnApproveLauncher');

    const reviewButton =
      document.getElementById('cvnSubmitReviewLauncher');

    const createButton =
      document.getElementById('cvnCreateDraftBtn');

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    const anchor =
      approveButton ||
      reviewButton ||
      createButton ||
      refreshButton;

    if (!anchor) return false;

    const button = document.createElement('button');

    button.id = 'cvnRevisionLauncher';
    button.type = 'button';
    button.textContent = 'Create Revision';

    anchor.insertAdjacentElement('afterend', button);

    button.addEventListener('click', openRevisionModal);

    return true;
  }
  window.CorevianOpenRevisionModal =
  openRevisionModal;

  function start() {
    injectStyles();
    installLauncher();

    const observer = new MutationObserver(function () {
      installLauncher();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();